import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RegistrationUtlFactory {
  public static readonly ALREADY_EXISTS_ERRORS = {
    EMAIL_AND_PHONE: "User with this email and phone already exists",
    EMAIL: "User with this email already exists",
    PHONE: "User with this phone number already exists"
  }

  public static readonly ERROR_MESSAGES = {
    EMAIL_ALREADY_EXISTS: 'registration_content.email_already_exists',
    PHONE_ALREADY_EXISTS: 'registration_content.phone_already_exists',
    UNEXPECTED: 'An unexpected error occurred'
  }
}
